import { StyleSheet } from 'aphrodite'

import table from './table'
import tableRow from './tableRow'

export default {
  table: StyleSheet.create(table),
  tableRow: StyleSheet.create(tableRow)
}



// WEBPACK FOOTER //
// ./src/components/Settings/partials/SettingsEditor/style/ColorBlind/index.js